/** Dash dashboard fields are the default across the app. Pass variant="legacy" only for old morphism markup. */
export function usesDashFormVariant(variant) {
  return variant !== 'legacy';
}
